export default __webpack_public_path__ + "static/media/editIcon.61ba392b.svg";